"use client";

import { Heart } from "lucide-react";

export function FavoriteVenueButton({
  venueName,
  active,
  busy,
  onToggle,
}: {
  venueName: string;
  active: boolean;
  busy: boolean;
  onToggle: () => void;
}) {
  return (
    <button
      type="button"
      className={`favorite-venue-button${active ? " is-favorite" : ""}`}
      aria-label={`${active ? "Remove" : "Add"} ${venueName} ${active ? "from" : "to"} favorites`}
      aria-pressed={active}
      disabled={busy}
      onClick={onToggle}
    >
      <Heart fill={active ? "currentColor" : "none"} />
      <span>{active ? "Saved" : "Save"}</span>
    </button>
  );
}
